<template>
  <transition name="modal">
    <div class="modal-mask" @click="close()">
      <div class="modal-wrapper">
        <div class="modal-container center" @click.stop >
          <div class="close" @click="close()">x</div>
          <div class="modal-header">
            <slot name="modal-header">
              <h5 class="bold"></h5>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="modal-body">
            </slot>
          </div>

          <div class="modal-footer" >
            <slot name="modal-footer">
            </slot>
          </div>
          <slot name="loader"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['showModal'],
  methods: {
    close: function () {
      this.$emit('close')
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (this.showModal && e.keyCode === 27) {
        this.close()
      }
    })
  }
}
</script>

<style lang="scss" src="./modal.scss"></style>



// WEBPACK FOOTER //
// modal.vue?71cff879